
(function($) {
	'use strict';

	var init = function(){
		//This date format should correspond to the date format used in 'getCalendarObject' function of calendar.php
		//And it should always be "Ymd" to correspond with the date format saved in database
		//See https://api.jqueryui.com/datepicker/#utility-formatDate
		var dateFormat = "yymmdd";

		$.each($('.ligue-calendar'), function() {
			//Inialize DOM variables
			var calendar = $(this).find('#calendar');
			var eventsContainer = $(this).find('#events');

			//Set jQuery datepicker
			//Doc: https://api.jqueryui.com/datepicker/
			calendar.datepicker({
				prevText: 'Mois précédent',
				nextText: 'Mois suivant',
				//Set clickable dates, and associated class
				beforeShowDay: function(date) {
					var isAvailableDate = false,
						items = calendarObject['items'];
					date = $.datepicker.formatDate(dateFormat, date);
					var pastDate = (date < $.datepicker.formatDate(dateFormat, new Date()));
					var className = pastDate ? "past-date " : ""
					for(var key in items){
						var typeHasDate = (String(date) in items[key]);
						if(typeHasDate && !pastDate){
							className += key+"-available ";
							items[key][date].forEach(function(id){
								className += "id-"+id+" ";
							});
							isAvailableDate = isAvailableDate || typeHasDate;
						}
					}
					//Expected array : [(boolean) clickable, (string) className, (string) tittleAttribute]
					return [isAvailableDate, className];
				},
				//On click event, load associated events
				onSelect: function(dateText, inst) {
					loadEvents($.datepicker.formatDate(dateFormat, calendar.datepicker('getDate')), eventsContainer);
				}
			});

			//Select and initialize event list if current day has events
			loadEvents($.datepicker.formatDate(dateFormat, new Date()), eventsContainer);
		});
	};

	var loadEvents = function(date, eventsContainer){
		setCalendarLoading(true);

		var eventsContainer = $('.ligue-calendar #events');
		
		$.ajax({
			url			: ajaxurl,
			type		: 'POST',
			data		: {
                'action': 'loadEventsList',
                'date': date,
            },
			success		: function(res){
                if(res){
                    eventsContainer.append(res);
                }
			},
			error		: function(res){
				console.error(JSON.parse(res));
			},
			complete	: function(res){
				setCalendarLoading(false);
			}
		});
	}

	var setCalendarLoading = function(isLoading){
		if(isLoading && !$('.ligue-calendar').hasClass('disabled')){
			//Calendar is loading events
			//Disable click, animate events suppression
			calendarObject.loading = true;
			$('.ligue-calendar #events').slideUp(200, function(){
				$(this).empty();
			});
			$('.ligue-calendar').addClass('disabled');
		} else {
			//Calendar finished loading events
			//Enable click, animate events suppression
			calendarObject.loading = false;
			$('.ligue-calendar #events').slideDown(200);
			$('.ligue-calendar').removeClass('disabled');
		}
	}

	$(document).ready(function(){
        if($('.ligue-calendar').length > 0)
		    init();
	});

})(jQuery);